export function Content() {
  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Content</h2>
      <p className="text-gray-600">Content management UI — to be implemented in Phase 4.</p>
    </div>
  );
}